import leaflet from 'leaflet';
window.leaflet = leaflet;
import '/node_modules/leaflet/dist/leaflet.css';